export default "__VITE_ASSET__AxKJ8M49__"